import { useState, useEffect } from 'react';
import './TabbedContainer.css';

const TabbedContainer = ({ tabs, initialTab = 0 }) => {
    const [activeTab, setActiveTab] = useState(initialTab);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 767);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="custom-tabs">
            <div className="tab-header-row">
                {tabs.map((tab, idx) => (
                    <button
                        key={tab.label}
                        className={`tab-btn${activeTab === idx ? ' active' : ''}`}
                        onClick={() => setActiveTab(idx)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className={`tab-body tab-body-${activeTab}`}>
                {typeof tabs[activeTab].content === 'function'
                    ? tabs[activeTab].content(isMobile)
                    : tabs[activeTab].content}
            </div>
        </div>
    );
};

export default TabbedContainer;